var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarouselRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.125,
    width: 24,
    height: 24,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.528 6.59231C10.2338 6.30073 9.75889 6.30284 9.46731 6.59704C9.17573 6.89124 9.17784 7.36611 9.47204 7.65769L11.235 9.405C11.9505 10.1141 12.4413 10.6022 12.7734 11.0157C13.096 11.4174 13.2067 11.6754 13.2361 11.9065C13.2546 12.0516 13.2546 12.1984 13.2361 12.3435C13.2067 12.5746 13.096 12.8326 12.7734 13.2343C12.4413 13.6478 11.9505 14.1359 11.235 14.845L9.47204 16.5923C9.17784 16.8839 9.17573 17.3588 9.46731 17.653C9.75889 17.9472 10.2338 17.9493 10.528 17.6577L12.3227 15.8789C12.9987 15.209 13.5511 14.6614 13.9429 14.1735C14.3504 13.6662 14.6453 13.1513 14.7241 12.5332C14.7586 12.2621 14.7586 11.9879 14.7241 11.7168C14.6453 11.0987 14.3504 10.5838 13.9429 10.0765C13.5511 9.58859 12.9987 9.04104 12.3227 8.37109L10.528 6.59231Z",
    fill: "#2D264B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselRight);
export default __webpack_public_path__ + "static/media/carousel_right.5a89d73b69d17970ba6f63d72e5f9c90.svg";
export { ForwardRef as ReactComponent };